import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { SystemClusterTraffic } from "@graylog/server-api";
import i18n from "i18n";
import { defaultOnError } from "util/conditional/onError";
const useClusterTraffic = (days) => {
  const { data: traffic, isLoading } = useQuery({
    queryKey: ["cluster", "traffic", days],
    queryFn: () => defaultOnError(
      SystemClusterTraffic.get(days, false),
      i18n.t("notifications.cluster_traffic_failed", { ns: "system" }),
      i18n.t("notifications.cluster_traffic_failed_title", { ns: "system" })
    ),
    enabled: !!days,
    placeholderData: keepPreviousData,
    staleTime: 3e4
  });
  return { traffic, isLoading };
};
export default useClusterTraffic;
